jQuery( function ( $ ) {

  $( document ).on( 'ajaxSuccess', function ( e, xhr, settings, response ) {
    if ( settings.data.includes( 'calc_shipping=x' ) ) {
      const $html = $.parseHTML( response, document, true );
      const $virtual_totals = $( '.cart_totals', $html );
      if ( $virtual_totals.length ) {
        const $dom_totals = $( '.cart_totals' );
        $( '.gform_wrapper + iframe', $virtual_totals ).each( function () {
          const $virtual_frame = $(this);
          const $script = $( '+ script', $virtual_frame );
          if ( $script.length ) {
            const $dom_frame = $( `iframe[name=${ $virtual_frame.attr( 'name' ) }]`, $dom_totals );
            if ( $dom_frame.length ) {
              $script.insertAfter( $dom_frame );
            }
          }
        });
      }
    }
  });

});